import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { DomUtil } from "../../util/DomUtil";
import { moduletracking } from "../../Wyanoke/ModuleTracking";
import { PageContext } from "../../service/PageContext";
import { UiUtil } from "../../util/UiUtil";

export class NextArticle extends Component {
  private _nextArticleRequested: Boolean = false;

  constructor(element: HTMLElement, context: PageContext) {
    super(element, context);

  }

  public async init(): Promise<void> {
    if (window.Visitor !== undefined && window.Visitor !== "") {
      this.botCheck();
    } else {
      $(window).on("globalsloaded", () => this.botCheck());
    }
  }

  public botCheck(): void {
    if (window.Visitor.isbot || window.Visitor.type === "DC") {
      return;
    }
    window.addEventListener("scroll", () => this.handleScroll());
  }

  public handleScroll(): void {
    const articleFooter = (<HTMLCollectionOf<HTMLElement>>document.getElementsByClassName("article__content--footer"));
    if (UiUtil.elementInViewport(articleFooter[0])) {
      if (!this._nextArticleRequested) {
        let recommendedUrl = this.getRecommendedUrl(".recommended-primary");

        if (!recommendedUrl) {

          return;
        }

        const currentDocId = window.Context && window.Context.documentid ? window.Context.documentid.replace("{", "").replace("}", "").toLowerCase() : null;

        // the next recommended is the current article; try the 2nd recommended
        if (recommendedUrl.split("/find/")[1] === currentDocId) {
          recommendedUrl = this.getRecommendedUrl(".recommended-one");
        }

        if (!recommendedUrl) {
          return;
        }

        let nextArticleId = recommendedUrl.split('/find/')[1];
        let nextArticleUrl = recommendedUrl + "?nextarticle=1";

        if (this._nextArticleRequested) {

          return;
        }

        this._nextArticleRequested = true;
        this.handleLoadingDisplay();

        var myHeaders = new Headers();
        myHeaders.append('pragma', 'no-cache');
        myHeaders.append('cache-control', 'no-cache');

        var requestInit = {
          method: 'GET',
          headers: myHeaders,
        };

        fetch(nextArticleUrl, requestInit).then(response => {
          if (response.ok) {
            recommendedUrl = response.url && response.url.length > 0 ?
              response.url.replace("?nextarticle=1", "") :
              nextArticleUrl.replace("?nextarticle=1", "")
            return response.text();
          }
          throw new Error('Invalid response while getting next article at: ' + nextArticleUrl);
        }).then(html => {
          let articleContainers = DomUtil.queryAll(document.body, '.article__container');
          const lastArticleContainer = articleContainers[articleContainers.length - 1];
          const articleInnerContentDiv = DomUtil.query(this._element, "[data-next-article='article_content_wrap']");
          const gradientDiv = DomUtil.query(this._element, "[data-next-article='gradient_overlay']");
          const continueReadingButton = DomUtil.query<HTMLAnchorElement>(this._element, "[data-next-article='continue_reading_button']");
          const continueReadingUrl = recommendedUrl ?? "#";
          continueReadingButton.href = continueReadingUrl;


          let tempDiv = document.createElement("div");
          tempDiv.innerHTML = html;

          const articleContainer = DomUtil.query(tempDiv, ".article__container");
          const nextArticleClass = "article_" + nextArticleId;
          articleContainer.classList.add(nextArticleClass);

          const articleContentDiv = DomUtil.query(tempDiv, ".article__content");
          articleContentDiv.setAttribute("data-no-ads", "true");
          articleInnerContentDiv.innerHTML = articleContentDiv.innerHTML;
          articleContentDiv.innerHTML = articleInnerContentDiv.outerHTML;

          const emailTopicAlertComponents = DomUtil.queryAll(articleContainer, "[data-component='EmailTopicAlert']");
          emailTopicAlertComponents.forEach(topicAlertCopmonent => topicAlertCopmonent.remove());

          const perspectiveLinks = DomUtil.queryAll<HTMLAnchorElement>(articleContainer, ".perspective > a");
          perspectiveLinks.forEach(perspectAElement => perspectAElement.setAttribute("href", continueReadingUrl));

          const mobileTrustBox = DomUtil.query(articleContainer, ".mobile-trust-box");
          mobileTrustBox.insertAdjacentHTML('afterend', gradientDiv.outerHTML);

          articleContentDiv.insertAdjacentHTML('beforeend', continueReadingButton.outerHTML);

          const leftColumn = DomUtil.query(articleContainer, ".article__left-col");
          leftColumn.setAttribute("style", "margin-top: 5px;");
          leftColumn.insertAdjacentHTML('beforeend', gradientDiv.outerHTML);

          lastArticleContainer.insertAdjacentHTML('afterend', articleContainer.outerHTML);

          const articleTop = DomUtil.query(tempDiv, "[data-article-container='top']", false)
          if (articleTop && articleTop.innerHTML) {
            articleContainers = DomUtil.queryAll(document.body, '.article__container');
            const newLastArticleContainer = articleContainers[articleContainers.length - 1];
            let articleTopDiv = document.createElement("div");
            articleTopDiv.classList.add("article_top");
            articleTopDiv.classList.add("article_top_" + nextArticleId);
            articleTopDiv.innerHTML = articleTop.innerHTML;
            newLastArticleContainer.insertAdjacentHTML('beforebegin', articleTopDiv.outerHTML);
          }

          this.loadNextArticleComponents(nextArticleClass);
          const nextArticleElement = DomUtil.query(document.body, "." + nextArticleClass);
          moduletracking.AjaxTrackLinks(nextArticleElement, "NextArticle");
          this.handleLoadingDisplay();
          this._element.remove();
        }).catch(error => {
          this.handleLoadingDisplay();
          console.error(error);
        })
      }


    }
  }

  private async loadNextArticleComponents(nextArticleClass: string): Promise<void> {
    const nextArticleElement = DomUtil.query(document.body, ("." + nextArticleClass))
    await this._pageContext?.componentFactory.loadComponents(nextArticleElement)
  }

  private getRecommendedUrl(recommendedClass: string): string | null {
    const firstRecommended = DomUtil.query(document.body, recommendedClass);
    if (!firstRecommended) {
      return null
    }

    const recommendedAElement = DomUtil.query<HTMLAnchorElement>(firstRecommended, 'a');
    if (!recommendedAElement) {
      return null
    }

    // recommended hasn't loaded yet
    if (recommendedAElement.href.indexOf(window.location.toString()) > -1) {
      return null
    }

    return recommendedAElement.href
  }

  private handleLoadingDisplay(): void {
    const loadingDiv = DomUtil.query(document.body, "[data-next-article='spinner']")
    if (loadingDiv) {
      const showLoading = !loadingDiv.classList.contains("active");
      if (showLoading) {
        loadingDiv.classList.add("active");
      } else {
        loadingDiv.classList.remove("active");
      }
    }
  }

}
ComponentFactory.registerComponent("NextArticle", NextArticle);
